import { Icon } from '@toggle/design-system';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { CardType } from '../../StreamCard';
import styles from './CardPill.module.scss';

interface CardPillProps {
  type: CardType;
}

const typeClassName = (type: CardType) =>
  styles[CardType[type] as keyof typeof styles];

export const CardPill = ({ type }: CardPillProps) => {
  const { t } = useTranslation(['stream']);

  const renderPill = () => {
    switch (type) {
      case CardType.CompanyCatalyst:
        return (
          <>
            <div
              className={clsx(styles.iconWrapper, typeClassName(type))}
            >
              <Icon
                iconName="PuzzleBorderless"
                size={12}
                fillColor="var(--icon-decorative-lime)"
                viewBox="0 0 12 12"
              />
            </div>
            <div className={clsx(styles.titleLabel, typeClassName(type))}>
              {t('stream:pills.companyCatalyst')}
            </div>
          </>
        );
      case CardType.MarketCatalyst:
        return (
          <>
            <div
              className={clsx(styles.iconWrapper, typeClassName(type))}
            >
              <Icon
                iconName="PuzzleBorderless"
                size={12}
                fillColor="var(--icon-decorative-cyan)"
                viewBox="0 0 12 12"
              />
            </div>
            <div className={clsx(styles.titleLabel, typeClassName(type))}>
              {t('stream:pills.marketCatalyst')}
            </div>
          </>
        );
      case CardType.MarketSummary:
        return (
          <>
            <div
              className={clsx(styles.iconWrapper, typeClassName(type))}
            >
              <Icon
                iconName="Newspaper"
                size={12}
                fillColor="var(--icon-decorative-gold)"
              />
            </div>
            <div className={clsx(styles.titleLabel, typeClassName(type))}>
              {t('stream:pills.marketSummary')}
            </div>
          </>
        );
      case CardType.Scenario:
        return (
          <>
            <div
              className={clsx(styles.iconWrapper, typeClassName(type))}
            >
              <Icon
                className={styles.styledScenarioIcon}
                iconName="ExploreNav"
                size={12}
                fillColor="var(--icon-decorative-indigo)"
              />
            </div>
            <div className={clsx(styles.titleLabel, typeClassName(type))}>
              {t('stream:pills.scenario')}
            </div>
          </>
        );
      case CardType.EarningsPreview:
        return (
          <>
            <div
              className={clsx(styles.iconWrapper, typeClassName(type))}
            >
              <Icon
                iconName="EarningsPreviewBorderless"
                size={12}
                viewBox="0 0 12 12"
                fillColor="var(--icon-decorative-purple)"
              />
            </div>
            <div className={clsx(styles.titleLabel, typeClassName(type))}>
              {t('stream:pills.preview')}
            </div>
          </>
        );
      case CardType.EarningsRecap:
        return (
          <>
            <div
              className={clsx(styles.iconWrapper, typeClassName(type))}
            >
              <Icon
                iconName="EarningsRecapBorderless"
                size={12}
                viewBox="0 0 12 12"
                fillColor="var(--icon-decorative-teal)"
              />
            </div>
            <div className={clsx(styles.titleLabel, typeClassName(type))}>
              {t('stream:pills.recap')}
            </div>
          </>
        );
      default:
        return null;
    }
  };

  return <div className={styles.styledPillWrapper}>{renderPill()}</div>;
};
